export default __webpack_public_path__ + "static/media/gmail.ca00a183.svg";